




























































































































































































































































import { conditionalOperators, mathOperators } from '@/constants'
import { FormulaModel, FormulaModelType, FormulasInputContainer } from '@/types/FormulaFieldType'
import { SearchConfigField } from '@/types/utilTypes'
import { generateUniqueId } from '@/utils'
import _ from 'lodash'
import Vue from 'vue'
import Draggable from 'vuedraggable'

export default Vue.extend({ 
    components: { Draggable },
    data() {
        const formulaTypes = Object.values(FormulaModelType)
        return {
            formulaTypes,
            FormulasInputContainer,
        }
    },
    props: {
        formulas: {
            type: Array as () => FormulaModel[]
        },
        fields: {
            type: Array as () => SearchConfigField[]
        },
        containerType: {
            type: String as () => FormulasInputContainer,
            default: FormulasInputContainer.Main
        },
        colorMap: {
            type: Object as () => Record<string, string>,
        },
        isActionFinal: {
            type: Boolean,
            default: false
        },
        parent: {
            type: String,
            default: 'Formulas'
        },
        validationErrors: {
            type: Object as () => Record<string, string>,
            default: () => ({}) as Record<string, string>
        }
    },
    name: 'FormulasInput',
    methods: {
        createNewFormulaModel(modelType: FormulaModelType): FormulaModel {
            return {
                id: generateUniqueId(),
                type: modelType,
                value: '',
                condition: [],
                then: [],
                else: []
            }
        },
        retrieveItems(formulaType: FormulaModelType) {
            switch (formulaType) {
            case FormulaModelType.Field:
                return this.fieldAliases
            case FormulaModelType.ConditionalOperator:
                return conditionalOperators
            case FormulaModelType.Operator:
                return mathOperators
            default:
                return []
            }
        },
        isConditionalFormula(formula: FormulaModel): boolean {
            return formula.type === FormulaModelType.If
        },
        isValueFormula(formula: FormulaModel): boolean {
            return formula.type === FormulaModelType.Value
        },
        addFormula(formulaType: FormulaModelType) {
            this.formulas.push(this.createNewFormulaModel(formulaType))
        },
        removeFormula(index: number) {
            if (index >= 0 && index < this.formulas.length) {
                const formula = this.formulas[index]
                if(this.isConditionalFormula(formula)) {
                    delete this.colorMap[formula.id ?? '']
                }
                this.formulas.splice(index, 1)
            }
        },
        duplicateFormula(formula: FormulaModel) {
            const newFormula = _.cloneDeep(formula)
            newFormula.id = generateUniqueId() // Ensure the new formula has a unique ID
            this.formulas.push(newFormula)
        },
        generateFormulaStyle(formula: FormulaModel): string {
            if (!this.isConditionalFormula(formula)) {
                return ''
            }
            // If the formula is conditional, apply a specific style
            let id = formula.id ?? 'unknown'
            const color = this.colorMap[id] || '#ffffff'
            return `background-color: ${color}; border: 1px solid ${color}; `
        }
    },
    computed: {
        fieldAliases(): string[] {
            return this.fields.map(field => field.alias)
        },
        generatedFormulaTypes(): FormulaModelType[] {
            if(this.containerType=== FormulasInputContainer.If) {
                return this.formulaTypes
            }
            return this.formulaTypes.filter(type => type !== FormulaModelType.ConditionalOperator)
        }
    },
})
